import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "components/Header/HeaderLogin.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import loginPageStyle from "assets/jss/material-kit-pro-react/views/loginPageStyle.jsx";
import image from "assets/img/gris2.jpg";
import Globales from "utils/Globales";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import CookiesU from 'universal-cookie';
const cookies = new CookiesU();
class LoginPage extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      Usuario: '',
      Contrasena: '',
      errorUsuario: '',
      errorContrasena: '',
      colorNotificacion: 'success',
      mensaje: '',
      br: false,
      NombreUsuario: ''
    }
    global.nombreUsuario = '';
    this.IniciarSesion = this.IniciarSesion.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.enterFunction = this.enterFunction.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.addEventListener("keypress", this.enterFunction, false);
  }

  enterFunction(event) {
    if (event.keyCode === 13) {
      this.IniciarSesion();
    }
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }

  IniciarSesion() {
    //Validar que los campos no esten vacios
    if (this.state.Usuario !== '' && this.state.Contrasena !== '') {
      fetch(Globales.Url + 'IniciarSesion', {
        method: 'POST', headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json'
        }, body: JSON.stringify(this.state)
      })
        .then(res => res).then(data => {
          if (data.status !== 404) {
            var a = data.json();
            a.then(r => {
              this.setState({ auth: r });
              if (this.state.auth.response == true) {
                document.removeEventListener("keypress", this.enterFunction, false);
                cookies.set('Usuario', this.state.auth.usuario.Usuario, { path: '/' });
                cookies.set('NombreUsuario', this.state.auth.usuario.NombreUsuario, { path: '/' });
                cookies.set('TipoUsuario', this.state.auth.usuario.TipoUsuario, { path: '/' });
                cookies.set('id', this.state.auth.usuario._id, { path: '/' });
                cookies.set('token', this.state.auth.token, { path: '/' });
                Globales.token = 'Bearer ' + cookies.get('token');
                let dt = new Date();
                localStorage.setItem('expira', new Date(dt.getTime() + 20 * 60000));
                window.location.href = '#/MenuPrincipal';
                cookies.set('mensaje', 'Bienvenido ' + this.state.auth.usuario.NombreUsuario, { path: '/' });
                window.location.reload()
              }
            });
          } else {
            this.setState({ colorNotificacion: 'danger', mensaje: 'Usuario y/o Contraseña incorrectos' });
            this.showNotification();
          }
        });
    } else {
      this.setState({ errorUsuario: true, errorContrasena: true, colorNotificacion: 'danger', mensaje: 'Complete los campos para iniciar sesión' });
      this.showNotification();
    }
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header
          absolute
          color="transparent"
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + image + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center"
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={4}>
                <Card>
                  <form className={classes.form}>
                    <CardHeader
                      color="info"
                      signup
                      className={classes.cardHeader}
                    >
                      <h4>Administración Nook</h4>
                    </CardHeader>
                    <CardBody signup>
                      <CustomInput
                        labelText="Usuario"
                        id="first"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          required: true,
                          onChange: this.handleChange.bind(this),
                          value: this.state.Usuario,
                          name: "Usuario",
                          id: "Usuario",
                          type: "text",
                          error: this.state.errorUsuario
                        }}
                      />

                      <CustomInput
                        labelText="Contraseña"
                        id="pass"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          required: true,
                          onChange: this.handleChange.bind(this),
                          value: this.state.Contrasena,
                          name: "Contrasena",
                          id: "Contrasena",
                          type: "password",
                          error: this.state.errorContrasena
                        }}
                      />
                    </CardBody>
                  </form>
                  <div className={classes.textCenter}>
                    <Button type="submit" round color="default" onClick={this.IniciarSesion.bind(this)}>Iniciar Sesión</Button>
                  </div>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(LoginPage);
